// app/features/invoices/invoicesSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Invoice } from "../context";
import { Meta, Links } from "./constant";

interface InvoicesState {
  data: Invoice[] | null;
  loading: boolean;
  error: string | null;
  meta: Meta | null;
  links: Links | null;
}

const initialState: InvoicesState = {
  data: null,
  loading: false,
  error: null,
  meta: null,
  links: null,
};

const invoicesSlice = createSlice({
  name: "invoices",
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
      if (action.payload) state.error = null;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setInvoices(
      state,
      action: PayloadAction<{
        items: Invoice[];
        meta: Meta;
        links: Links;
      }>
    ) {
      state.data = action.payload.items;
      state.meta = action.payload.meta;
      state.links = action.payload.links;
      state.loading = false;
      state.error = null;
    },
    fetchInvoicesStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchInvoicesSuccess(
      state,
      action: PayloadAction<{
        items: Invoice[];
        meta: Meta;
        links: Links;
      }>
    ) {
      state.data = action.payload.items;
      state.meta = action.payload.meta;
      state.links = action.payload.links;
      state.loading = false;
      state.error = null;
    },
    fetchInvoicesFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  setLoading,
  setError,
  setInvoices,
  fetchInvoicesStart,
  fetchInvoicesSuccess,
  fetchInvoicesFailure,
} = invoicesSlice.actions;

export default invoicesSlice.reducer;